export default "__VITE_ASSET__BXXHFAO4__"